import { FatalAssertInstanceError, TypedNode } from '@rehaje/core'
import { createElement, Fragment, memo, useMemo } from 'react'

import { TypedNodeProvider } from './TypedNodeProvider'

import type { ViewComponent } from './types'
import type { FC, PropsWithChildren } from 'react'

export interface RecursionViewProps {
  /**
   * TypedNode 实例
   */
  node: TypedNode
}

/**
 * 递归渲染组件
 * @param props
 * @returns
 */
export const RecursionView: FC<PropsWithChildren<RecursionViewProps>> = memo(
  (props) => {
    if (!(props.node instanceof TypedNode))
      throw new FatalAssertInstanceError('TypedNode')

    const node = props.node
    const element = props.node.__r_getSelfViewElement()
    const model = element?.model
    const component = useMemo(
      () => node.__r_store.plugin.getViewComponentClass(node.type) ?? Fragment,
      [node]
    ) as ViewComponent

    if (!model && node.isEntityNode())
      console.error(`${node.id}(${node.type})'s view model not found`)

    return (
      <TypedNodeProvider node={node}>
        {createElement(component, { model, node }, props.children)}
      </TypedNodeProvider>
    )
  }
)

RecursionView.displayName = 'RecursionView'
